import BaseService from '../baseService';
import { GetTagsRequest, Tag, GetLinksRequest, GetLookupsRequest, SaveLinksRequest } from './contracts';

export default class extends BaseService {
    constructor() {
        super('api/tags');
    }

    /**
    * Gets tags.
    * @param {Object<GetTagsRequest>} filter - Filters for tags.
    * @returns list of tags.
    */
    getTags = (filter: Partial<GetTagsRequest>) => this.httpPostRequest(`list`, filter);

    /**
    * Gets tag.
    * @param {number} tagId - tagId.
    * @returns tag item.
    */
    getTag = (tagId: number) => this.httpGetRequest(`${tagId}`);

    /**
    * Saves created or edited tag.
    * @param {Object<Tag>} tag - Tag object.
    * @returns void.
    */
    saveTag = (tag: Partial<Tag>) => this.httpPutRequest('', tag);

    /**
    * Deletes tags.
    * @param {Array<number>} tagIds - TagIds.
    * @returns void.
    */
    deleteTags = (tagIds: number[]) => this.httpPostRequest("delete", tagIds);

    /**
    * Gets links.
    * @param {Object<GetLinksRequest>} filter - Links Filter.
    * @returns list of links.
    */
    getLinks = (filter: Partial<GetLinksRequest>) => this.httpPostRequest(`links`, filter);

    /**
    * Gets lookups for createble serch.
    * @param {Object<GetLookupsRequest>} filter - Links Filter and filters.
    * @returns list of string.
    */
    getLookup = (filter: Partial<GetLookupsRequest>) => this.httpPostRequest(`lookup`, filter);

    /**
    * Deletes linked scenarios
    * @param {Object} filter
    * @param {Array<number>} filter.tagIds - tag Ids
    * @param {Array<number>} filter.scenarioIds - scenario Ids
    * @returns void.
    */
    deleteLinks = (filter: { tagIds: number[]; scenarioIds: number[] }) => this.httpPostRequest(`deleteLinks`, filter);

    /**
    * Saves linked scenarios
    * @param {Object<SaveLinksRequest>} links
    * @returns void.
    */
    saveLinks = (links: SaveLinksRequest) => this.httpPutRequest('link', links);
}
